import {
  Button,
  Card,
  DatePicker,
  Divider,
  Input,
  message,
  Modal,
  Space,
  Statistic,
  Tabs
} from 'antd'
import React, { useEffect, useState } from 'react'
import service from '../../../@services'
import SelectStores from '../components/SelectStores'
import AfterSaleTable from '../components/AfterSaleTable'
import AuthComponent from '../../../components/AuthComponent'
import BasicForm from '../components/BasicForm'
import Selector from '../components/Selector'
import * as Utils from '../../../@utils'
import { ExclamationCircleOutlined } from '@ant-design/icons'
const { RangePicker } = DatePicker

/**
 * @param {Object} values 需要格式化的对象
 * @param {String} formatStr 格式化样式 默认'YYYY-MM-DD HH:mm:ss'
 * @returns Object
 */
const format = (values, formatStr = 'YYYY-MM-DD HH:mm:ss') => {
  if (!values) return {}
  values.afterAftersaleTime = values.aftersaleTime
    ? values.aftersaleTime[0].startOf('day').format(formatStr)
    : null
  values.beforeAftersaleTime = values.aftersaleTime
    ? values.aftersaleTime[1].endOf('day').format(formatStr)
    : null
  return { ...values }
}

const AfterSaleList = props => {
  const aftersaleNo = props.location.query?.aftersaleNo
  const [defaultValue, setDefaultValue] = useState({})
  const [init, setInit] = useState(false)
  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    pageIndex: 1,
    pageSize: 20,
    aftersaleNo: aftersaleNo
  })
  const [amount, setAmount] = useState(0)
  const [num, setNum] = useState(0)
  const [total, setTotal] = useState(0)
  const [list, setList] = useState([])
  /** tab数据**/
  const defaultActiveKey = 'UN_AUDIT'
  const [activeKey, setActiveKey] = useState('UN_AUDIT')
  const onChangeTab = activeKey => {
    setActiveKey(activeKey)
  }
  const [selectedRowKeys, onSelectChange] = useState([])
  const [reasonModalVisible, setReasonModalVisible] = useState(false)
  const [reason, setReason] = useState('')
  const [singleR, setSingleR] = useState(null)

  /** 初始化渲染门店选择框 */
  const setDefault = values => {
    setDefaultValue({ storeCode: [values] })
    if (aftersaleNo) {
      setDefaultValue({ aftersaleNo: aftersaleNo })
    }
    if (init) return
    setInit(true)
    setFormData({ ...formData, storeCode: [values], auditStatus: 'UN_AUDIT' })
  }
  /** 表单筛选项字段及组件 */
  const fields = [
    {
      label: '所属门店',
      name: 'storeCode',
      component: <SelectStores onOptionLoad={setDefault} />
    },
    {
      label: '订单来源',
      name: 'chan',
      component: <Selector tag='orderChan' />
    },
    {
      label: '订单类型',
      name: 'orderTypes',
      component: <Selector tag='orderType' />
    },
    {
      label: '商品信息',
      name: 'productInfo',
      placeholder: '商品名称/条码/商品编码'
    },
    { label: '订单号', name: 'orderNo' },
    { label: '售后单号', name: 'aftersaleNo' },
    {
      label: '支付渠道',
      name: 'payWay',
      component: <Selector tag='payWay' keyValue='name' />
    },
    { label: '购买人姓名', name: 'buyerName' },
    { label: '购买人电话', name: 'buyerPhone' },
    {
      label: '退款原因',
      name: 'aftersaleReason',
      component: <Selector tag='aftersaleReason' keyValue='name' />
    },
    {
      label: '售后类型',
      name: 'aftersaleType',
      component: <Selector tag='aftersaleType' />
    },
    {
      label: '创建时间',
      name: 'aftersaleTime',
      component: (
        <RangePicker allowClear placeholder={['开始日期', '结束日期']} />
      )
    }
  ]
  /** 获取售后列表 */
  const getAfterSaleList = () => {
    setLoading(true)
    let p1 = service.order.getAfterSaleList({ ...formData })
    let p2 = service.order.queryAfterSaleStatistics({ ...formData })
    return Promise.all([p1, p2])
      .then(res => {
        setLoading(false)
        const { result, recordCount } = res[0] || {}
        const { amount, num } = res[1] || {}
        setList(result || [])
        setTotal(recordCount || 0)
        setAmount(amount || 0)
        setNum(num || 0)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  /** 查询 */
  const submit = values => {
    let formatValues = format(values)
    setFormData({ ...formData, ...formatValues })
  }
  const onHandler = async (type, r) => {
    const params = {}
    if (r) {
      params.afterSaleNos = [r.aftersaleNo]
    } else {
      if (selectedRowKeys.length == 0) {
        message.info('请选择订单')
        return
      } else {
        params.afterSaleNos = selectedRowKeys
      }
    }
    if (type == 'pass') {
      Modal.confirm({
        title: '提示',
        icon: <ExclamationCircleOutlined />,
        content: (
          <div>
            确认<span style={{ color: 'red' }}>通过</span>
            所选申请吗？审核通过退货商品将自动退款
          </div>
        ),
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          try {
            const res = await service.order.getAfterSaleApprove(params)
            console.log(res)
            await message.success('操作成功', 1)
            getAfterSaleList()
          } catch (e) {
            console.log(e)
          }
        }
      })
    } else if (type == 'nopass') {
      setReason('')
      if (r) {
        setSingleR(r)
      } else {
        setSingleR(null)
      }
      setReasonModalVisible(true)
    } else if (type == 'noPassSubmit') {
      if (!reason) {
        return message.warning('请填写驳回原因')
      }
      const res = await service.order.getAfterSaleReject({
        ...params,
        cause: reason
      })
      console.log(res)
      await message.success('操作成功', 1)
      setReasonModalVisible(false)
      getAfterSaleList()
    }
  }
  /** 导出 */
  const onExport = async values => {
    let formatValues = format(values)
    setFormData({ ...formData, ...formatValues })
    let file = await service.order.exportAfterSale({
      ...formData,
      ...formatValues
    })
    const filename =
      '门店售后订单报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  }
  /** 明细导出 */
  const onExportDetail = async (values) => {
    let formatValues = format(values)
    setFormData({ ...formData, ...formatValues })
    let file = await service.order.exportAftersaleProduct({
      ...formData,
      ...formatValues,
    })
    const filename =
      '门店售后订单商品明细报表' + Utils.parseTime(Date.parse(new Date())) + '.xlsx'
    Utils.download(file, filename)
  }
  useEffect(() => {
    init && getAfterSaleList()
  }, [init, formData])
  useEffect(() => {
    if (init) {
      onSelectChange([])
      setFormData({ ...formData, auditStatus: activeKey })
    }
  }, [activeKey])
  return (
    <div className='aftersale-page'>
      <BasicForm
        name='aftersale'
        fields={fields}
        onSearch={submit}
        onExport={onExport}
        onExportDetail={onExportDetail}
        defaultValue={defaultValue}
        authKey={{ search: '/after-sale/list', export: '/after-sale/export' }}
      />
      <Card style={{ marginBottom: '15px' }}>
        <Tabs defaultActiveKey={defaultActiveKey} onChange={onChangeTab}>
          <Tabs.TabPane tab='待审核' key='UN_AUDIT' />
          <Tabs.TabPane tab='已完成' key='AUDIT' />
          <Tabs.TabPane tab='已关闭' key='REJECT' />
        </Tabs>
        {activeKey == 'UN_AUDIT' ? (
          <div>
            <AuthComponent authKey='/after-sale/approve'>
              <Button
                style={{ marginRight: '10px' }}
                onClick={() => onHandler('pass')}
                type='primary'>
                批量通过
              </Button>
            </AuthComponent>
            <AuthComponent authKey='/after-sale/reject'>
              <Button type='primary' onClick={() => onHandler('nopass')}>
                批量驳回
              </Button>
            </AuthComponent>
          </div>
        ) : (
          ''
        )}
      </Card>
      <Card>
        <Space
          className='total-box'
          size='large'
          split={<Divider type='vertical' />}>
          <Statistic title='总金额(元)' value={amount} />
          <Statistic title='交易笔数(笔)' value={num} />
        </Space>
        <AfterSaleTable
          rowSelection={
            activeKey == 'UN_AUDIT'
              ? {
                  onChange: onSelectChange,
                  selectedRowKeys: selectedRowKeys
                }
              : null
          }
          onHandler={onHandler}
          auditStatus={activeKey}
          loading={loading}
          list={list}
          total={total}
          page={formData}
          submit={(pages = {}) => setFormData({ ...formData, ...pages })}
        />
      </Card>
      <Modal
        visible={reasonModalVisible}
        width='400px'
        title='提示'
        onCancel={() => {
          setReasonModalVisible(false)
        }}
        onOk={() => onHandler('noPassSubmit', singleR)}
        cancelText='取消'
        okText='确认'>
        <>
          <div style={{ marginBottom: '10px' }}>
            确认<span style={{ color: '#ff0000' }}>驳回</span>所选申请吗？
          </div>
          <div style={{ display: 'flex', width: '100%' }}>
            <div>驳回理由:</div>
            <Input.TextArea
              value={reason}
              style={{ width: '280px' }}
              onChange={({ target }) => {
                setReason(target.value)
              }}
              maxLength={50}
              showCount
              placeholder='请输入拒绝理由'
              rows={2}
            />
          </div>
        </>
      </Modal>
    </div>
  )
}
export default AfterSaleList
